<template>
  <div class="criterionOverView">
    <button
      v-if="
        !isLoading &&
          !editMode &&
          $IsUserInRole('KlauselauspraegungAdministration')
      "
      v-b-tooltip.hover
      class="btn btn-primary float-right mb-2"
      placement="bottom"
      title="Klauselausprägung bearbeiten"
      type="button"
      @click="editMode = true"
    >
      <i class="fas fa-edit" />
    </button>
    <h4
      class="card-title font-weight-bold"
      style="margin-bottom: 40px"
    >
      Klauselnausprägung
    </h4>
    <div
      v-if="!isLoading && editMode"
      class="buttonWrapper mb-2 mt-4"
    >
      <button
        class="btn btn-success ml-2"
        type="button"
        @click="saveConfiguration()"
      >
        Speichern
      </button>

      <button
        class="btn btn-secondary ml-2"
        type="button"
        @click="loadConfiguration()"
      >
        Abbrechen
      </button>
    </div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      class="mt-4"
    />
    <u-loader v-if="isLoading" />

    <table
      v-else
      class="w-100 table table-sm"
    >
      <thead>
        <tr>
          <th>Titel</th>
          <th>Untertitel</th>
          <th>Klausel Name</th>
          <th
            v-for="(property, index) in properties"
            :key="index"
          >
            {{ property.DisplayName }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(config, index) in allTopLevelCriterions"
          :key="index"
        >
          <td>{{ GetTitleForCriterion(config.path) }}</td>
          <td>{{ GetSubTitleForCriterion(config.path) }}</td>
          <td>{{ config.value }}</td>
          <td
            v-for="(property, propertyIndex) in properties"
            :key="propertyIndex"
          >
            <div class="form-check pl-0">
              <label>
                <input
                  v-model="config[property.PropertyName]"
                  :disabled="
                    !editMode ||
                      !(
                        property.PropertyName === 'isAve' ||
                        property.PropertyName === 'isTenantGavService' ||
                        property.PropertyName === 'isTenantUnia' ||
                        property.PropertyName === 'isTenantSeco' ||
                        property.PropertyName === 'isTenantTempData' ||
                        property.PropertyName === 'isTenantWorkcontrol' ||
                        property.PropertyName === 'useWhenNoPvl' ||
                        property.PropertyName === 'isImportantKlausel'
                      )
                  "
                  :title="property.DisplayName"
                  type="checkbox"
                >
                <span class="label-text" />
              </label>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-if="!isLoading && editMode"
      class="buttonWrapper"
    >
      <button
        class="btn btn-success ml-2"
        type="button"
        @click="saveConfiguration()"
      >
        Speichern
      </button>

      <button
        class="btn btn-secondary ml-2"
        type="button"
        @click="loadConfiguration()"
      >
        Abbrechen
      </button>
    </div>
  </div>
</template>

<script>
import {
  LoadAllCriterionConfigurations,
  SaveConfiguration,
} from "@/services/criterion.management.service.js";

export default {
  data() {
    return {
      properties: [
        {
          PropertyName: "isAve",
          DisplayName: "Ave-Relevant",
        },
        {
          PropertyName: "isTenantGavService",
          DisplayName: "Tenant GavService",
        },
        {
          PropertyName: "isTenantUnia",
          DisplayName: "Tenant Unia",
        },
        {
          PropertyName: "isTenantTempData",
          DisplayName: "Tenant TempData",
        },
        {
          PropertyName: "isTenantSeco",
          DisplayName: "Tenant Seco",
        },
        {
          PropertyName: "isTenantWorkcontrol",
          DisplayName: "Tenant Workcontrol",
        },
        {
          PropertyName: "useWhenNoPvl",
          DisplayName: "Vertragsloser-Zustand-PVL",
        },
        {
          PropertyName: "isImportantKlausel",
          DisplayName: "Wichtige Klauseln",
        },
      ],
      isLoading: false,
      errorObject: null,
      allCriterionConfiguration: null,
      editMode: false,
    };
  },
  computed: {
    allTopLevelCriterions() {
      return this.allCriterionConfiguration.filter((criterion) => {
        return !criterion.isRootGroup;
      });
    },
  },
  created() {
    this.loadConfiguration();
  },
  methods: {
    GetTitleForCriterion(path) {
      var splitPath = path.split(/\//g || []);

      var criterionTitleObject = this.allCriterionConfiguration.filter(
        (criterionConfig) => {
          var splitObjectPath = criterionConfig.path.split(/\//g || []);
          return (splitObjectPath.length =
            2 && splitObjectPath[0] == splitPath[0]);
        },
      );

      if (criterionTitleObject[0]) {
        return criterionTitleObject[0].value;
      } else {
        return "";
      }
    },
    GetSubTitleForCriterion(path) {
      var splitPath = path.split(/\//g || []);

      var criterionSubTitleObject = this.allCriterionConfiguration.filter(
        (criterionConfig) => {
          var splitObjectPath = criterionConfig.path.split(/\//g || []);
          return (splitObjectPath.length =
            3 &&
            splitObjectPath[0] == splitPath[0] &&
            splitObjectPath[1] == splitPath[1]);
        },
      );

      if (criterionSubTitleObject[0]) {
        return criterionSubTitleObject[0].value;
      } else {
        return "";
      }
    },
    loadConfiguration() {
      this.editMode = false;
      this.isLoading = true;
      this.errorObject = null;

      LoadAllCriterionConfigurations(
        (response) => {
          this.allCriterionConfiguration = JSON.parse(JSON.stringify(response));
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    saveConfiguration() {
      this.isLoading = true;
      this.errorObject = null;

      this.allCriterionConfiguration.map((config) => {
        config.id = config.klauselTypeId;
      });

      SaveConfiguration(
        this.allCriterionConfiguration,
        () => {
          this.loadConfiguration();
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
  },
};
</script>

<style>
.criterionOverView input[type="checkbox"]:disabled + .label-text:before {
  color: #909090;
}
</style>

<style scoped>
td:nth-child(1) {
  width: 10%;
}

td:nth-child(2) {
  width: 20%;
}

td:nth-child(3) {
  width: 20%;
}

td:nth-child(4) {
  width: 10%;
}

td:nth-child(5) {
  width: 10%;
}

td:nth-child(6) {
  width: 10%;
}

td:nth-child(7) {
  width: 10%;
}

.filterSymbol {
  cursor: pointer;
}

.selectedFilter {
  color: red;
}
</style>
